import type { ReactElement } from "react";
import { PfMark } from "../../shell/Brand";
import { Icon } from "../../ui/Icon/Icon";
import { Button } from "../../ui/Button/Button";
import accessMark from "./access-mark.svg";
import styles from "./MeGate.module.css";

export type MeGateState = "loading" | "forbidden" | "error";

export interface MeGateProps {
  state: MeGateState;
  onRetry: () => void;
  onSignOut: () => void;
}

export function MeGate({
  state,
  onRetry,
  onSignOut,
}: MeGateProps): ReactElement {
  if (state === "forbidden") {
    return (
      <div className={styles.screen}>
        <div className={styles.inner}>
          <img className={styles.illustration} src={accessMark} alt="" />
          <h1 className={styles.title}>You don&apos;t have access</h1>
          <p className={styles.text}>
            Your account isn&apos;t authorised for the Developer Network. Contact
            your Property Finder representative if you think this is a mistake.
          </p>
          <Button variant="secondary" onClick={onSignOut}>
            Sign out
          </Button>
        </div>
      </div>
    );
  }

  if (state === "error") {
    return (
      <div className={styles.screen}>
        <div className={styles.inner}>
          <img className={styles.illustration} src={accessMark} alt="" />
          <h1 className={styles.title}>Couldn&apos;t load your account</h1>
          <p className={styles.text}>
            We couldn&apos;t reach Property Finder to verify your access. Check
            your connection and try again.
          </p>
          <Button
            variant="secondary"
            iconLeft={<Icon name="refresh" size={16} />}
            onClick={onRetry}
          >
            Try again
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.screen}>
      <div className={styles.inner}>
        <PfMark size={36} className={styles.mark} />
        <div className={styles.track}>
          <div className={styles.bar} />
        </div>
        <h1 className={styles.title}>Loading your workspace</h1>
        <p className={styles.text}>Checking your Property Finder access.</p>
      </div>
    </div>
  );
}
